import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";

function OrderManagementview() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const EventId = searchParams.get("id");
    const [eventDetails, setEventDetails] = useState(null);
    const [greetingCardDetails, setGreetingCardDetails] = useState([]);
    const [giftDetails, setGiftDetails] = useState([]);

    useEffect(() => {
        if (!EventId) {
            navigate(`/ordermanagement`);
        } else {
            fetchData();
        }
    }, [EventId]);

    const fetchData = () => {
        axios
            .get(`${process.env.REACT_APP_APIURL}event/list?event_id=${EventId}`)
            .then((res) => {
                if (res.data.status === "success") {
                    setEventDetails(res.data.result);
                    fetchGreetingAndGiftDetails(res.data.result.cart);
                }
            })
            .catch((err) => {
                console.error("Error fetching events:", err);
            });
    };


    const fetchGreetingAndGiftDetails = (cartItems) => {
        const greetingCardIds = cartItems
            .filter((item) => item.greeting_card)
            .map((item) => {
                return {
                    greeting_card: item.greeting_card,
                    order_data_count: item.order_data_count,
                };
            });

        const giftIds = cartItems
            .filter((item) => item.gift)
            .map((item) => {
                return {
                    gift: item.gift,
                    order_data_count: item.order_data_count,
                };
            });

        console.log(greetingCardIds);
        console.log(giftIds);

        // Create arrays to store the results
        let greetingCards = [];
        let gifts = [];

        // Fetch greeting cards data
        const greetingCardPromises = greetingCardIds.map((item) => {
            return axios
                .get(`${process.env.REACT_APP_APIURL}greeting/list?greeting_id=${item.greeting_card}`)
                .then((res) => {
                    const updatedResult = {
                        ...res.data.result,
                        orderCount: item.order_data_count,  // Add item.order to the response
                    };
                    greetingCards.push(updatedResult); // Collect results
                })
                .catch((err) => {
                    console.error("Error fetching greeting card details for ID:", item.greeting_card, err);
                });
        });

        // Fetch gift data
        const giftPromises = giftIds.map((item) => {
            return axios
                .get(`${process.env.REACT_APP_APIURL}gift/list?gift_id=${item.gift}`)
                .then((res) => {
                    const updatedResult = {
                        ...res.data.result,
                        orderCount: item.order_data_count,  // Add item.order to the response
                    };
                    gifts.push(updatedResult); // Collect results
                })
                .catch((err) => {
                    console.error("Error fetching gift details for ID:", item.gift, err);
                });
        });

        // Once all data is fetched, update the state in a single call
        Promise.all([...greetingCardPromises, ...giftPromises]).then(() => {
            setGreetingCardDetails(greetingCards);  // Set all greeting card details at once
            setGiftDetails(gifts);  // Set all gift details at once
        });
    };




    if (!eventDetails) {
        return <div>Loading...</div>;
    }

    return (
        <div className="wrapper">
            <header>
                <NavigationBar />
            </header>

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 txt_lft">Order Management View</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb justify-content-end">
                                    <li className="breadcrumb-item">
                                        <a href="/ordermanagement">
                                            <i className="fa-solid fa-arrow-left-long mr-2" />
                                            Back
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Event Name</label>
                                                    <div>{eventDetails.event_name}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Event Date</label>
                                                    <div>{eventDetails.event_date}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Event Type</label>
                                                    <div>{eventDetails.event_type}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Greeting Notes</label>
                                                    <div>{eventDetails.greeting_notes}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Phone Number</label>
                                                    <div>{eventDetails.phone_number}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Zip Code</label>
                                                    <div>{eventDetails.zip_code}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Address</label>
                                                    <div>{eventDetails.address}</div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <h5>Greeting Cards</h5>
                                                <div className="row">
                                                    {greetingCardDetails.map((card) => (
                                                        <div key={card._id} className="col-12 col-md-4">
                                                            <div className="card">
                                                                <img
                                                                    src={card.url}
                                                                    alt={card.name}
                                                                    className="card-img-top"
                                                                />
                                                                <div className="card-body">
                                                                    <h5 className="card-title">{card.name}</h5>
                                                                    <p className="card-text">Price: {card.price}</p>
                                                                    <p className="card-text">
                                                                        <strong>Quantity: {card.orderCount}</strong>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Gifts */}
                                            <div className="col-12">
                                                <h5>Gifts</h5>
                                                <div className="row">
                                                    {giftDetails.map((gift) => (
                                                        <div key={gift._id} className="col-12 col-md-4">
                                                            <div className="card">
                                                                <img
                                                                    src={gift.url}
                                                                    alt={gift.name}
                                                                    className="card-img-top"
                                                                    
                                                                />
                                                                <div className="card-body">
                                                                    <h5 className="card-title">{gift.name}</h5>
                                                                    <p className="card-text">Price: {gift.price}</p>
                                                                    <p className="card-text">Quantity: {gift.orderCount}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default OrderManagementview;
